/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Decrypted document content, base64-encoded, for preview/download.
 * @export
 * @interface PamDocumentContent
 */
export interface PamDocumentContent {
    /**
     * 
     * @type {string}
     * @memberof PamDocumentContent
     */
    base64: string;
    /**
     * 
     * @type {string}
     * @memberof PamDocumentContent
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof PamDocumentContent
     */
    fileName: string;
}

/**
 * Check if a given object implements the PamDocumentContent interface.
 */
export function instanceOfPamDocumentContent(value: object): value is PamDocumentContent {
    if (!('base64' in value) || value['base64'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function PamDocumentContentFromJSON(json: any): PamDocumentContent {
    return PamDocumentContentFromJSONTyped(json, false);
}

export function PamDocumentContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamDocumentContent {
    if (json == null) {
        return json;
    }
    return {
        
        'base64': json['base64'],
        'contentType': json['contentType'],
        'fileName': json['fileName'],
    };
}

export function PamDocumentContentToJSON(value?: PamDocumentContent | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'base64': value['base64'],
        'contentType': value['contentType'],
        'fileName': value['fileName'],
    };
}

